import React from 'react';
import styled from 'styled-components';
import { device } from '../../assets/device'
import EventSummary from './EventSummary';
import EventSportSummary from './EventSportSummary';
import * as dates from '../../services/dates';
import merchantConfig from '../../merchant/config/merchant-config';

export const MonthOverviewStyles = {
	MonthTitle: styled.div`
		margin: 40px 0 0 0;

		h1 {
			background: #F7F7F7;
			background: -moz-linear-gradient(top,#e6e6e6,#F7F7F7);
			background: -webkit-gradient(linear,left top,left bottom,from(#e6e6e6),to(#F7F7F7));
			position: relative;
			font-size: 2em;
			text-transform: uppercase;
			margin: 1em 0 1em 0;
			line-height: 1.5;
			padding: 1rem 1rem 1rem 1.5rem;
          	//noinspection ALL
			@media ${device.tablet} {
				padding: 10px 20px;
				margin-left: 0;
				width: 100%;
				padding: .6rem 1rem .6rem 1.5rem;
				margin-bottom: 1.5em;
				font-size: 1.2em;
			}
		}
	`,

	EventList: styled.ul`
			list-style: none;
			margin: 0;
	`,

	EventListItem: styled.li`
		display: grid;
		margin-bottom: 1em;
		padding: 0 1.5rem 3.5em;
		border-bottom: 1px solid #e6e6e6;
		&:last-child {
			border-bottom: none;
			padding-bottom: 1em;
		}
	`,

	MonthListItem: styled.li`
		margin: 0;
	`,
};

const S = MonthOverviewStyles;

const showSportSummary = merchantConfig.showSportSummary;

const MonthOverview = ({ monthNumber, year, events }) => (
	<S.MonthListItem>
		<S.MonthTitle>
			<h1> {dates.MONTH_NAMES[monthNumber]} - {year} <span className="arrow" /> </h1>
		</S.MonthTitle>
		<S.EventList>
			{
				events.sort((a, b) =>
					dates.parseDatetimeString(a.begin).diff(dates.parseDatetimeString(b.begin)))
					.map(event => (
						<S.EventListItem key={event.uuid}>
							{showSportSummary ?
							<EventSportSummary event={event} /> :
							<EventSummary event={event} />}
						</S.EventListItem>
					))
			}
		</S.EventList>
	</S.MonthListItem>
);

export default MonthOverview;
